import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertApi } from '../../../apis/AlertApi/AlertApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export function useMarkAlertVisited() {
    const queryClient = useQueryClient();

    return useMutation<void, AppMedError, number>({
        mutationKey: [QueryKeys.alerts, 'visit'],
        mutationFn: async (id: number) => {
            return await AlertApi.visitAlert(id);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alerts] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.patientAlerts] });
        },
    });
}
